/*
  GENERATED by scripts/topic-icons.py. Do not edit this file; edit the table in that script
  and run it again. It also writes public/branding/icons.html from the same table, which is
  the point: the published reference page cannot drift from what the product draws. A note
  added here by hand was silently overwritten the first time the script was re-run.

  A mark for what a table item is about.

  The reference this product was redesigned against is a clothing app, so every card it
  shows carries a photograph and the eye can skim a page without reading it. The Table has
  no photographs and never will: its cards are the owner's own sentences about a van, a
  tech, a contract. An icon is the nearest honest equivalent. It gives each row something to
  catch the eye and, once an owner has seen the same mark a few times, something to skim by.

  ── The colour carries the kind of concern ──────────────────────────────────

  Six families, not thirty. The tint says what species of problem this is before a word is
  read: money, people, work, risk, market, admin. That is worth more than thirty unrelated
  colours, which would be decoration.

  Every mark clears 4.5:1 on its own tint (5.36 at the worst, the gold). The tints
  themselves are about 1.2:1 against a white card, so they read as a soft ground rather
  than as a block of colour competing with the sentence beside them.

  These are NOT the seat ramps and must not become them. A ramp belongs to a member for the
  life of that member, and a topic tile sitting in the same list in the same colour would
  make a subject look like a person.
*/
export type TopicFamily = 'money' | 'people' | 'work' | 'risk' | 'market' | 'admin'

export interface TopicSpec { family: TopicFamily; label: string; body: string }

export const TOPICS = {
  /* rates, quotes, what to charge */
  pricing: { family: 'money' as TopicFamily, label: "Pricing",
    body: "<path d=\"M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-6.2-6.2A2 2 0 0 1 3.8 13V5.8a2 2 0 0 1 2-2H13a2 2 0 0 1 1.4.6l6.2 6.2a2 2 0 0 1 0 2.8Z\"/><circle cx=\"8.6\" cy=\"8.6\" r=\"1.4\"/>" },
  /* pay, raises, overtime */
  wages: { family: 'money' as TopicFamily, label: "Wages",
    body: "<rect x=\"2.5\" y=\"6.5\" width=\"19\" height=\"11\" rx=\"2\"/><circle cx=\"12\" cy=\"12\" r=\"2.6\"/><path d=\"M6 10v4M18 10v4\"/>" },
  /* money in against money out */
  cashflow: { family: 'money' as TopicFamily, label: "Cash flow",
    body: "<path d=\"M4 8h11M4 8l3-3M4 8l3 3\"/><path d=\"M20 16H9M20 16l-3-3M20 16l-3 3\"/>" },
  /* what is owed to you */
  invoice: { family: 'money' as TopicFamily, label: "Invoices",
    body: "<path d=\"M6 3h9l4 4v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z\"/><path d=\"M14 3v5h5\"/><path d=\"M12 11v6M10.3 12.2h2.6a1.4 1.4 0 0 1 0 2.8h-1.8a1.4 1.4 0 0 0 0 2.8h2.6\"/>" },
  /* loans, finance, the bank */
  debt: { family: 'money' as TopicFamily, label: "Debt",
    body: "<path d=\"M3 9.5 12 4l9 5.5\"/><path d=\"M5 10v8M10 10v8M14 10v8M19 10v8\"/><path d=\"M3 20.5h18\"/>" },
  /* returns, VAT, the accountant */
  tax: { family: 'money' as TopicFamily, label: "Tax",
    body: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M8.6 15.4 15.4 8.6\"/><circle cx=\"9.2\" cy=\"9.2\" r=\"1.1\"/><circle cx=\"14.8\" cy=\"14.8\" r=\"1.1\"/>" },
  /* a vacancy, a new start */
  hiring: { family: 'people' as TopicFamily, label: "Hiring",
    body: "<circle cx=\"10\" cy=\"8\" r=\"3.2\"/><path d=\"M4 20c0-3.3 2.7-5.5 6-5.5 1.2 0 2.3.3 3.2.8\"/><path d=\"M17.5 14v6M14.5 17h6\"/>" },
  /* staff, the team, morale */
  crew: { family: 'people' as TopicFamily, label: "The crew",
    body: "<circle cx=\"9\" cy=\"8.5\" r=\"2.8\"/><circle cx=\"16.5\" cy=\"9.5\" r=\"2.2\"/><path d=\"M3.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5\"/><path d=\"M15 14.8c2.7.2 4.5 2.1 4.5 4.7\"/>" },
  /* a resignation, a dismissal */
  leaving: { family: 'people' as TopicFamily, label: "Someone leaving",
    body: "<path d=\"M14 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8\"/><path d=\"M11 12h10M21 12l-3.2-3.2M21 12l-3.2 3.2\"/>" },
  /* a specific client or account */
  customer: { family: 'people' as TopicFamily, label: "A customer",
    body: "<circle cx=\"12\" cy=\"8\" r=\"3.4\"/><path d=\"M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6\"/>" },
  /* reviews, referrals, word of mouth */
  reviews: { family: 'people' as TopicFamily, label: "Reputation",
    body: "<path d=\"m12 3.6 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.8l5.9-.9L12 3.6Z\"/>" },
  /* the van, the truck, the fleet */
  vehicle: { family: 'work' as TopicFamily, label: "A vehicle",
    body: "<path d=\"M2.5 16V8a1 1 0 0 1 1-1h9.5v9\"/><path d=\"M13 10h3.6l3.9 3.4V16\"/><circle cx=\"7\" cy=\"17.5\" r=\"2\"/><circle cx=\"17\" cy=\"17.5\" r=\"2\"/><path d=\"M9 16h6\"/>" },
  /* kit, plant, what it is worth */
  tools: { family: 'work' as TopicFamily, label: "Tools",
    body: "<path d=\"M15.4 7.4a4 4 0 0 1 5.1-5.1l-3 3 2.2 2.2 3-3a4 4 0 0 1-5.1 5.1L5.9 20.3a2.3 2.3 0 0 1-3.2-3.2L15.4 7.4Z\"/>" },
  /* the diary, capacity, lead times */
  scheduling: { family: 'work' as TopicFamily, label: "Scheduling",
    body: "<rect x=\"3.5\" y=\"5\" width=\"17\" height=\"15.5\" rx=\"2\"/><path d=\"M3.5 9.8h17M8.5 2.8v4M15.5 2.8v4\"/><path d=\"M8 13.5h3M8 17h7\"/>" },
  /* parts, merchants, what is on the shelf */
  stock: { family: 'work' as TopicFamily, label: "Materials",
    body: "<path d=\"M3.5 7.6 12 3.4l8.5 4.2v8.8L12 20.6l-8.5-4.2V7.6Z\"/><path d=\"M3.5 7.6 12 11.9l8.5-4.3M12 11.9v8.7\"/>" },
  /* an incident, RAMS, near misses */
  safety: { family: 'risk' as TopicFamily, label: "Safety",
    body: "<path d=\"M3.5 17.5h17\"/><path d=\"M5.6 17.5v-2.2a6.4 6.4 0 0 1 12.8 0v2.2\"/><path d=\"M9.6 9.6V5.8a1.4 1.4 0 0 1 1.4-1.4h2a1.4 1.4 0 0 1 1.4 1.4v3.8\"/>" },
  /* cover, claims, renewals */
  insurance: { family: 'risk' as TopicFamily, label: "Insurance",
    body: "<path d=\"M12 3.2 4.6 6v6.1c0 4.3 3.1 7.6 7.4 8.7 4.3-1.1 7.4-4.4 7.4-8.7V6L12 3.2Z\"/><path d=\"m8.8 12.2 2.2 2.2 4.2-4.2\"/>" },
  /* a dispute, a solicitor, a claim */
  legal: { family: 'risk' as TopicFamily, label: "Legal",
    body: "<path d=\"M12 3.4v17M6.5 20.6h11\"/><path d=\"M4 7.4h16M6.8 7.4 4 13.2h5.6L6.8 7.4ZM17.2 7.4 14.4 13.2H20l-2.8-5.8Z\"/>" },
  /* terms, a job won, the small print */
  contract: { family: 'risk' as TopicFamily, label: "A contract",
    body: "<path d=\"M6 3h8l4.5 4.5V15\"/><path d=\"M13.5 3v5h5\"/><path d=\"M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4\"/><path d=\"m13.6 20.4 6.6-6.6a1.7 1.7 0 0 0-2.4-2.4l-6.6 6.6-.7 3.1 3.1-.7Z\"/>" },
  /* a callback, rework, a complaint */
  quality: { family: 'risk' as TopicFamily, label: "Quality",
    body: "<path d=\"M12 4.2 2.8 20h18.4L12 4.2Z\"/><path d=\"M12 10.4v3.8M12 17.2v.1\"/>" },
  /* ads, leads, getting the phone to ring */
  marketing: { family: 'market' as TopicFamily, label: "Marketing",
    body: "<path d=\"M3.5 9.5v5h3.2l7.3 4.4V5.1L6.7 9.5H3.5Z\"/><path d=\"M17.6 8.8a4.6 4.6 0 0 1 0 6.4M19.9 6.2a8 8 0 0 1 0 11.6\"/>" },
  /* who else is bidding */
  competitor: { family: 'market' as TopicFamily, label: "A competitor",
    body: "<path d=\"M5 21V3.6M5 4.4h10.5l-1.6 3.2 1.6 3.2H5\"/><path d=\"M19 21V9.4M19 10.2h-3\"/>" },
  /* more work, a second crew, expansion */
  growth: { family: 'market' as TopicFamily, label: "Growth",
    body: "<path d=\"M3.5 19.5h17\"/><path d=\"m5 16 4.4-4.8 3.4 2.8L20 6.5\"/><path d=\"M15.6 6.5H20V11\"/>" },
  /* software, the CRM, paperwork */
  technology: { family: 'market' as TopicFamily, label: "Systems",
    body: "<rect x=\"2.8\" y=\"4.5\" width=\"18.4\" height=\"12\" rx=\"1.6\"/><path d=\"M8.5 20.5h7M12 16.5v4\"/><path d=\"m9.6 9.2-1.8 1.8 1.8 1.8M14.4 9.2l1.8 1.8-1.8 1.8\"/>" },
  /* anything that does not fit the rest */
  question: { family: 'admin' as TopicFamily, label: "A question",
    body: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M9.4 9.5a2.7 2.7 0 0 1 5.2.9c0 1.8-2.6 2.3-2.6 4\"/><path d=\"M12 17.4v.1\"/>" },
}

export type TopicName = keyof typeof TOPICS

/*
  The path data is set with dangerouslySetInnerHTML because it is a static string in the
  table above rather than a JSX tree, which keeps that table readable. It is the operator's
  own artwork and nothing user-submitted can reach it. If that ever stops being true this
  needs sanitising, or turning into real elements.
*/
export function TopicIcon({ name, size }: { name: TopicName; size?: number }) {
  const spec = TOPICS[name]

  /*
    The colour is not passed in. data-family is, and styles/topics.css resolves it, which is
    what lets the tile flip with the theme: the light tints are far too bright on a dark
    card and each family has a dark pair. An inline style could not do that.
  */
  return (
    <span
      className="topic"
      data-family={spec.family}
      style={size ? { width: size, height: size } : undefined}
      role="img"
      aria-label={spec.label}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6}
           strokeLinecap="round" strokeLinejoin="round" aria-hidden
           dangerouslySetInnerHTML={{ __html: spec.body }} />
    </span>
  )
}
